import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import PaperClipIcon from '~/components/SVG/PaperClip.svg?react';

interface PaperClipProps {
  isActive?: boolean;
  isError?: boolean;
}

const styles = {
  icon:
    (isActive = false, isError = false) =>
    (theme: Theme) => ({
      color: isError
        ? theme.palette.error.main
        : isActive
          ? theme.palette.primary.main
          : theme.palette.grey.additionalGrey,
    }),
};

const PaperClip = ({ isActive, isError }: PaperClipProps) => {
  return <Box component={PaperClipIcon} sx={styles.icon(isActive, isError)} />;
};

export default PaperClip;
